import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	MatAutocompleteModule,
	MatButtonModule,
	MatDialogModule,
	MatIconModule,
	MatInputModule,
	MatMenuModule,
	MatRadioModule,
	MatTableModule,
	MatTooltipModule
} from '@angular/material';
import { RouterModule } from '@angular/router';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { SaveStateData } from 'dbweb-core';
import { RecordViewInnerModule } from './../record-view/record-view-inner.module';
import { BannerComponent } from './banner/banner.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ChartComponent } from './chart/chart.component';
import { DataListComponent } from './data-list/data-list.component';
import { IndexComponent } from './index.component';
import { MoreVertComponent } from './more-vert/more-vert.component';
import { NavigationComponent } from './navigation/navigation.component';
import { NoticeComponent } from './notice/notice.component';
import { SettingDialogComponent } from './setting-dialog/setting-dialog.component';
import { WelcomeComponent } from './welcome/welcome.component';
@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		MatMenuModule,
		MatDialogModule,
		MatRadioModule,
		MatIconModule,
		MatInputModule,
		MatButtonModule,
		MatTooltipModule,
		MatTableModule,
		FormsModule,
		ReactiveFormsModule,
		MatAutocompleteModule,
		RecordViewInnerModule,
		CalendarModule.forRoot({
			provide: DateAdapter,
			useFactory: adapterFactory
		}),
		RouterModule.forChild([
			{
				path: '**',
				component: IndexComponent,
				data: SaveStateData
			}
		])
	],
	declarations: [
		IndexComponent,
		WelcomeComponent,
		BannerComponent,
		NavigationComponent,
		DataListComponent,
		ChartComponent,
		SettingDialogComponent,
		CalendarComponent,
		NoticeComponent,
		MoreVertComponent
	],
	entryComponents: [SettingDialogComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class IndexModule {}
